import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import * as fromUi from "./core/actions/ui.actions";
import * as fromContact from "./core/actions/contact.actions";
import * as jwt_decode from "jwt-decode";
import * as actionSession from "./core/actions/session.actions";
import { NotificationsService } from "./shared/notifications/notifications.service";
import { OAuthService } from "angular-oauth2-oidc";
import { JwksValidationHandler } from "angular-oauth2-oidc";
import { environment } from "src/environments/environment";
import { NgxPermissionsService } from "ngx-permissions";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [],
})
export class AppComponent implements OnInit {
  title = "Comelex";

  public constructor(
    private store: Store<any>,
    private notificationsService: NotificationsService,
    private oauthService: OAuthService,
    private permissionService: NgxPermissionsService
  ) {
    let authConfig = {
      // Url of the Identity Provider
      issuer: "https://idp.jklm.be/746c6d1e-f92a-58f2-6016-c48ce947076c",

      // URL of the SPA to redirect the user to after login
      redirectUri: window.location.origin + "/index.html",
      oidc: true,
      // The SPA's id. The SPA is registered with this id at the auth-server
      clientId: "036775cb-1adf-4735-90cf-99ca9e4d5105",
      requireHttps: false,
      strictDiscoveryDocumentValidation: false,
      // set the scope for the permissions the cli ent should request
      // The first three are defined by OIDC. The 4th is a usecase-specific one
      scope: "openid profile email offline_access",
      silentRefreshTimeout: 5000, // For faster testing
      logoutUrl:
        "https://idp.jklm.be/oauth2/logout?client_id=036775cb-1adf-4735-90cf-99ca9e4d5105",
      timeoutFactor: 0.05, // For faster testing
      sessionChecksEnabled: false,
      showDebugInformation: true, // Also requires enabling "Verbose" level in devtools
      clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040
      responseType: "code",
    };

    //http://amande.lconsult.be:9011/.well-known/openid-configuration/97fca67e-924f-0c5b-07d7-2261a3e7058a
    this.oauthService.silentRefreshRedirectUri =
      window.location.origin + "/" + "silent-renew.html";
    this.oauthService.configure(authConfig);
    if (environment.production) {
      this.oauthService.setupAutomaticSilentRefresh();
    }
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();

    this.oauthService
      .loadDiscoveryDocument(
        "https://idp.jklm.be/6ad9281d-7d06-4f36-b7cb-97569c8c5ebd/.well-known/openid-configuration"
      )
      .then((doc) => {
        return this.oauthService.tryLogin().then(() => {
        });
      });
  }

  public ngOnInit() {
    this.store.dispatch(new fromUi.ActivateLoadingAction());
    this.store.select("ui").subscribe((s) => {
      console.log(s);
    });
    setTimeout(() => {
    const at = localStorage.getItem("access_token");
    if (at != null) {
      this.store.dispatch(new actionSession.CreateSession(jwt_decode(at)));
      console.log("Roles", jwt_decode(at).roles);
      this.permissionService.loadPermissions(jwt_decode(at).roles);
    }}, 1000);
  }
}
